<template>
    <div>
        <v-card class="mb-6 pa-3 pa-md-6 visit-info-card">
            <v-card-title class="pa-0 mb-3">
                반입물품 / 전자기기
                <v-btn
                    depressed
                    outlined
                    small
                    width="75"
                    color="var(--primary-color, #023894)"
                    class="ml-auto font-weight-bold"
                    :disabled="visitors.length === 0"
                    @click="addCarryInItem"
                >
                    등록
                    <v-icon right>mdi-archive-plus</v-icon>
                </v-btn>
            </v-card-title>
            <v-data-table
                :headers="headers"
                :items="innerInfo.carryInItems"
                :value="selectedItems"
                :items-per-page="-1"
                item-key="importId"
                no-data-text="반입 물품이 없습니다"
                hide-default-footer
                selectable-key="selectable"
                disable-sort
                @input="selectCarryInItem"
            >
                <template v-slot:item.visitorId="{ item }">
                    {{ getVisitorName(item.visitorId) }}
                </template>

                <template v-slot:item.actions="{ item }">
                    <template >
                        <v-icon
                            small
                            class="mr-2"
                            @click="editCarryIn(item)"
                        >
                            mdi-pencil
                        </v-icon>
                        <v-icon
                            small
                            @click="deleteCarryIn(item)"
                        >
                            mdi-delete
                        </v-icon>
                    </template>
                </template>

            </v-data-table>
        </v-card>

        <carry-in-dialog
            v-model="dialog.show"
            :target-item="dialog.item"
            :visitors="visitors"
            @save="saveCarryIn"
            @close="closeCarryInDialog"
        ></carry-in-dialog>
    </div>
</template>

<script>
import {mapState} from "vuex";
import CarryInDialog from "@/components/CarryInDialog.vue";
import ImportItemHelper from "@/service/importItemHelper";

export default {
    name: 'ApplyStep4',

    props: {
        value: Array,
        visitors: {
            type: Array,
            default: () => []
        }
    },

    components: {
        CarryInDialog
    },

    data: () => ({
        isLoading: false,
        selectedItems: [],
        headers: [
            {text: '방문자', value: 'visitorId', width: 150},
            {text: '물품종류', value: 'importType'},
            {text: '제조사', value: 'manufacturer'},
            {text: '모델명', value: 'model'},
            {text: '시리얼번호', value: 'serial'},
            {text: '액션', value: 'actions', width: 200, sortable: false},
        ],

        dialog: {
            show: false,
            item: null,
        },

        innerInfo: {
            carryInItems: [],
        },
    }),

    created() {
        this.init();
    },

    computed: {
        ...mapState(['currentUser', 'secretKey', 'iv']),
        fieldConfig() {
            return ImportItemHelper.parseImportItemColumnsConfig(this.$code.get('service.config.import_item_columns'))
        }
    },

    watch: {
        'innerInfo.carryInItems': {
            handler(v) {
                this.$emit('input', v);
            },
            deep: true
        },
    },

    methods: {
        init() {
            this.innerInfo.carryInItems = this.value;
            this.headers = ImportItemHelper.cleanUnusedHeaders(this.headers, this.fieldConfig);
        },

        editCarryIn(carryInItem) {
            this.dialog.item = carryInItem;
            this.dialog.show = true;
        },

        deleteCarryIn(carryInItem) {
            const idx = this.innerInfo.carryInItems.findIndex(v => v.importId === carryInItem.importId);
            this.innerInfo.carryInItems.splice(idx, 1);
        },

        deleteCarryIns() {
            this.selectedItems.forEach(v => {
                this.deleteCarryIn(v);
            })
        },

        selectCarryInItem(selectCarryInItem) {
            this.selectedItems = selectCarryInItem;
        },

        addCarryInItem() {
            this.dialog.show = true;
            this.dialog.item = null;
        },

        saveCarryIn(carryInItem) {
            const foundItem = this.innerInfo.carryInItems.find(e => e.importId === carryInItem.importId);

            if (foundItem) {
                Object.assign(foundItem, carryInItem);
            } else {
                this.innerInfo.carryInItems.push(carryInItem);
            }

            this.dialog.item = null;
        },

        // 반입 물품 관련 함수
        closeCarryInDialog() {
            this.dialog.item = null;
            this.dialog.show = false;
        },

        getVisitorName(visitorId) {
            const visitor = this.visitors.find(v => v.visitorId === visitorId);
            return visitor ? visitor.visitorName : null;
        },

    }

}
</script>

<style scoped>
>>> .v-data-table__empty-wrapper td {
    font-size: 1rem !important;
}
</style>